import { FC } from 'react';

import { Icon, Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

export const MicrophoneNoAudioDetected: FC<{ compact?: boolean }> = ({
  compact,
}) => {
  const { t } = useTranslation();

  if (compact) {
    return (
      <Stack
        gap={3}
        align="center"
        justify="between"
        className="rounded-lg border border-border-primary bg-bg-tertiary px-3 py-2.5"
        direction="horizontal"
      >
        <div className="text-text-primary">
          <Icon name="Mic" />
        </div>
        <Stack align="center" fullWidth={false} gap={2} direction="horizontal">
          <div className="rounded-full bg-bg-warning-strong-primary p-0.5 text-text-warning-strong">
            <Icon name="AlertCircle" />
          </div>
          <Text color="tertiary" size="xs">
            {t('microphone.noAudioDetectedCompact')}
          </Text>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack
      align="center"
      className="rounded-lg border border-border-primary bg-bg-tertiary p-8 pt-[3.375rem]"
      gap={6}
    >
      <div className="relative grid place-items-center rounded-full bg-bg-strong-secondary p-4 text-text-strong">
        <Icon name="Mic" size="xl" />
        <div className="absolute -bottom-1 -left-1 rounded-full bg-bg-warning-strong-primary p-px text-text-warning-strong">
          <Icon name="AlertCircle" size="lg" />
        </div>
      </div>
      <Text className="max-w-60 text-center" color="tertiary" size="xs">
        {t('microphone.noAudioDetectedFull')}
      </Text>
    </Stack>
  );
};
